var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_vm._v(_vm._s(_vm.copyright)+", "),_c('a',{attrs:{"href":_vm.imprint}},[_vm._v("Impressum")])])])}
var staticRenderFns = []

export { render, staticRenderFns }